import { render } from "./ResultScreen.vue?vue&type=template&id=dd7d839c&scoped=true"
import script from "./ResultScreen.vue?vue&type=script&lang=js"
export * from "./ResultScreen.vue?vue&type=script&lang=js"

import "./ResultScreen.vue?vue&type=style&index=0&id=dd7d839c&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd7d839c"]])

export default __exports__